import { getSupabaseClient } from './providers'
import type { DiscoveryRepository, LoopRepository, ModerationRepository, NotificationRepository, RemixRepository, SocialRepository } from './providers'
import type { Draft } from './types'
import { createSupabaseRepositories, demoRepositories } from './repositories'

export interface RepositoryBundle {
  loops: LoopRepository
  social: SocialRepository
  discovery: DiscoveryRepository
  notifications: NotificationRepository
  moderation: ModerationRepository
  remix: RemixRepository
}

let bundlePromise: Promise<RepositoryBundle> | undefined

export const serverMode = import.meta.env.VITE_DATA_MODE === 'supabase'

export function getRepositoryBundle(): Promise<RepositoryBundle> {
  if (bundlePromise) return bundlePromise
  const created: Promise<RepositoryBundle> = (async () => {
    if (!serverMode) return demoRepositories
    const client = await getSupabaseClient()
    if (!client) throw new Error('Cross-device mode is configured without a Supabase client.')
    return createSupabaseRepositories(client)
  })()
  bundlePromise = created
  return created
}

export async function optimisticNetworkAction(localAction: () => void, remoteAction: (repositories: RepositoryBundle) => Promise<unknown>): Promise<void> {
  localAction()
  if (!serverMode) return
  try { await remoteAction(await getRepositoryBundle()) } catch (error) { localAction(); throw error }
}

export async function syncDraftToBeta(draft: Draft): Promise<void> {
  if (!serverMode) return
  const client = await getSupabaseClient(); if (!client) throw new Error('Beta draft sync is unavailable.')
  const { data: { user } } = await client.auth.getUser(); if (!user) throw new Error('Sign in to sync this draft.')
  const { error } = await client.from('drafts').upsert({ id: draft.id, owner_id: user.id, payload: draft, updated_at: new Date().toISOString() })
  if (error) throw error
}
